import React, { useState, useEffect } from "react";
import { Title } from "../../atoms/Title/title";
import Check from "../../molecules/Check";
import SVGS from "../../atoms/svgs";

const StepOne = ({
  template,
  data,
  nextStep,
  disableNextStep,
  enableNextStep,
  handleOnchageRadio,
  formData,
}) => {
  const [usCitizenshipInput, setUsCitizenshipInput] = useState({
    value: "1",
    error: false,
  });
  const isModalBlue = template === "blue";

  useEffect(() => {
    if (!isModalBlue) {
      usCitizenshipInput.value === "1" && formData.value !== ""
        ? enableNextStep()
        : disableNextStep();
    } else {
      setUsCitizenshipInput({
        ...usCitizenshipInput,
        error: usCitizenshipInput.value === "1" ? false : true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usCitizenshipInput.value, formData.value]);

  const handleNextStep = () => {
    if (usCitizenshipInput.value === "0") {
      setUsCitizenshipInput({ ...usCitizenshipInput, error: true });
      return;
    }
    nextStep();
  };

  const handleUsCitizenshipInput = () => {
    setUsCitizenshipInput({
      ...usCitizenshipInput,
      value: usCitizenshipInput.value === "1" ? "0" : "1",
    });
  };

  return (
    <>
      <div className="FormSelector__headings">
        <Title
          className="FormSelector__title"
          medium
          tag="h1"
          content={data.title}
        />
        {data.subtitle && <p className="FormSelector__subtitle">{data.subtitle}</p>}
      </div>
      <div className="FormSelector__content">
        <div className="FormSelector__options">
          {data.formOptions.map((option) => {
            const Icon = option.svg ? SVGS[option.svg] : null;
            return (
              <React.Fragment key={option.value}>
                <input
                  type="radio"
                  className="u-display-none"
                  id={option.value}
                  name="form-selector"
                  value={option.value}
                  checked={formData.value === option.value}
                  onChange={handleOnchageRadio}
                  onClick={isModalBlue ? handleNextStep : undefined}
                />
                <label
                  htmlFor={option.value}
                  className="FormSelector__option">
                  <Icon className="FormSelector__icon" />
                  <p className="FormSelector__optionCopy">{option.copy}</p>
                </label>
              </React.Fragment>
            );
          })}
        </div>
        <Check
          errorMessage={data.usCitizenshipInput.errorMessage}
          type="checkbox"
          class="FormSelector__terms input-full"
          name={data.usCitizenshipInput.name}
          link={data.usCitizenshipInput.link}
          required={true}
          value={usCitizenshipInput.value}
          checked={usCitizenshipInput.value}
          validate={!usCitizenshipInput.error}
          onChange={handleUsCitizenshipInput}
        />
        {!isModalBlue && (
          <span
            className="button button-primary FormSelector__button button--disabled"
            onClick={handleNextStep}
            onKeyDown={handleNextStep}
            role="button"
            tabIndex={0}>
            {data.buttonLabel}
          </span>
        )}
      </div>
    </>
  );
};

export default StepOne;
